import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import FullCalendar, {
  EventClickArg,
  EventContentArg,
} from "@fullcalendar/react"; //listMonth, listWeek, listDay, listYear
import moment from "moment";
import { useRef, useState } from "react";
import colors from "core/resources/theme/colors";
import Calendar from "ui/components/Calendar";
import {
  CalendarioEncomendaEvent,
  EncomendaDto,
} from "core/features/encomenda/typings";
import HeaderTable from "components/Page/HeaderTable";
import { FiltroEncomenda } from "./../ListaEncomenda/components/ListaEncomendaTable/hooks/useFiltroEncomenda";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { Button } from "@chakra-ui/react";
import { useLoading } from "ui/components/GlobalLoading";

interface CalendarioEncomendaProps {
  encomendas?: EncomendaDto[];
  onClick: (encomenda: EncomendaDto) => any;
  onChangeView?: () => any;
  loading?: boolean;
  onChangeDate: (start: string, end: string) => any;
  hideSearch?: boolean;
  hideOptionsView?: boolean;
  dateClick?: (data: string) => any;
  filtro: FiltroEncomenda;
  onChangeFiltro: (filtro: Partial<FiltroEncomenda>) => any;
  view: "CALENDARIO" | "LISTA";
}

function CalendarioEncomenda({
  encomendas = [],
  onClick,
  onChangeView,
  loading = false,
  onChangeDate,
  hideSearch,
  hideOptionsView,
  dateClick,
  view,
  filtro,
  onChangeFiltro,
}: CalendarioEncomendaProps) {
  const [localView, setLocalView] = useState("dayGridMonth");
  const calendarRef = useRef<FullCalendar | null>(null);

  const _eventos: CalendarioEncomendaEvent[] | undefined =
    encomendas?.map((encomenda) => ({
      ...encomenda,
      title: encomenda.unidade.numero,
      backgroundColor:
        localView === "dayGridMonth" ? colors.gray : colors.lightBlue,

      start: moment(encomenda.createdAt).startOf("day").toISOString(),
      end: moment(encomenda.createdAt).startOf("day").toISOString(),
    })) || [];

  const getReservaFromClickEvent = ({ event }: EventClickArg): EncomendaDto => {
    return {
      id: event._def.publicId,
      origem: event._def.extendedProps.origem,
      createdAt: event._def.extendedProps.createdAt,
      arquivos: event._def.extendedProps.arquivos,
      descricao: event._def.extendedProps.descricao,
      observacao: event._def.extendedProps.observacao,
      pessoa: event._def.extendedProps.pessoa,
      unidade: event._def.extendedProps.unidade,
      status: event._def.extendedProps.status,
      dataChegadaCondominio: event._def.extendedProps.dataChegadaCondominio,
    };
  };

  const handleEventClick = (event: EventClickArg) => {
    const encomenda = getReservaFromClickEvent(event);
    onClick(encomenda);
  };

  useLoading(loading);

  return (
    <>
      <Box
        boxShadow={"0 0 16px 3px rgba(0, 0, 0, 0.05)"}
        rounded="16px"
        mb="32px"
        p={2}
        bg={colors.white}
      >
        {!hideSearch ? (
          <Box mb={6}>
            <HeaderTable
              value={filtro.search || ""}
              onSearch={(v) => onChangeFiltro({ search: v })}
            >
              <Flex justifyContent="end" w="100%">
                <Button
                  color={colors.primary}
                  bg="none"
                  onClick={onChangeView}
                  gap={2}
                >
                  <AiOutlineUnorderedList />
                  Ver{view === "LISTA" ? " no calendário" : " em lista"}
                </Button>
              </Flex>
            </HeaderTable>
          </Box>
        ) : null}
        <Calendar
          renderEventContent={renderEventContent}
          ref={calendarRef}
          dateClick={dateClick}
          events={_eventos}
          setLocalView={setLocalView}
          handleEventClick={handleEventClick}
          hideOptionsView={hideOptionsView}
          onChangeDate={onChangeDate}
          displayEventTime={false}
          loading={loading}
        />
      </Box>
    </>
  );
}

function renderEventContent(eventInfo: EventContentArg) {
  const _eventProps = eventInfo.event._def.extendedProps as EncomendaDto;
  const isCalendarView = eventInfo.view.type === "dayGridMonth";
  return (
    <Flex
      title={eventInfo.event.title}
      ml={isCalendarView ? 0 : -6}
      rounded={isCalendarView ? "full" : "10px"}
      borderLeft={isCalendarView ? "none" : `10px solid ${colors.primary}`}
      px={2}
      color={colors.white}
      bg={eventInfo.event.backgroundColor}
      cursor="pointer"
      _hover={{
        boxShadow: `0 0 0 2px ${colors.primary}`,
        outlineColor: colors.primary,
      }}
      alignItems="center"
      h="28px"
    >
      {isCalendarView ? (
        eventInfo.event.title
      ) : (
        <Text
          flex={1}
          as="h4"
          color={isCalendarView ? colors.white : colors.primary}
          fontWeight={isCalendarView ? "none" : "bold"}
        >
          {_eventProps.pessoa.nome} - Unidade {_eventProps.unidade.numero}
        </Text>
      )}

      {isCalendarView ? null : (
        <Text flex={1} as="h4" color={colors.primary} fontWeight="bold">
          {_eventProps.descricao}
        </Text>
      )}
    </Flex>
  );
}

export default CalendarioEncomenda;
